// Check if user is in the US based on locale/timezone
export const isUSLocale = () => {
    if (typeof window === 'undefined') return false;
    const lang = navigator.language || navigator.userLanguage;
    if (lang === 'en-US') return true;
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return tz?.startsWith('America/') && !tz?.includes('Argentina') && !tz?.includes('Sao_Paulo');
    } catch {
        return false;
    }
};

// Get home language code based on locale
export const getHomeLanguageCode = () => {
    return isUSLocale() ? 'US' : 'EN';
};
